// src/components/maintenance/tabs/SectorsTab.js
import React, { useState, useEffect, useContext } from "react";
import { Card, Row, Col, Table, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndustry } from "@fortawesome/free-solid-svg-icons";
import api from "../../../axiosConfig";
import { MaintenanceContext } from "../../../contexts/MaintenanceContext";
import { useNavigate } from "react-router-dom";
import "./css/Sectortab.css";

const SectorsTab = () => {
  const { loading: contextLoading } = useContext(MaintenanceContext);
  const [sectors, setSectors] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [sectorStats, setSectorStats] = useState({});

  // Fetch sectors data
  useEffect(() => {
    const fetchSectors = async () => {
      try {
        setLoading(true);
        const sectorsRes = await api.get("/sectors");
        const machinesRes = await api.get("/machines");
        setSectors(sectorsRes.data || []);

        // Calculate stats for each sector
        const stats = {};
        sectorsRes.data.forEach((sector) => {
          const sectorMachines = machinesRes.data.filter((m) => {
            const machineSectorId = m.sector?.id ?? m.sector_id;
            return Number(machineSectorId) === Number(sector.id);
          });

          // ✅ DEFINISIKAN DULU
          const operational = sectorMachines.filter(
            (m) => m.status === "Operational",
          ).length;

          const needMaintenance = sectorMachines.filter(
            (m) => m.status === "Need Maintenance",
          ).length;

          const underMaintenance = sectorMachines.filter(
            (m) => m.status === "Under Maintenance",
          ).length;

          stats[sector.id] = {
            totalMachines: sectorMachines.length,
            operational,
            needMaintenance,
            underMaintenance,
            healthPercentage:
              sectorMachines.length > 0
                ? Math.round((operational / sectorMachines.length) * 100)
                : 0,
          };
        });

        setSectorStats(stats);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching sectors:", err);
        setLoading(false);
      }
    };

    fetchSectors();
  }, []);

  if (loading || contextLoading) {
    return <div>Memuat data sektor...</div>;
  }

  // Fungsi untuk mendapatkan warna badge berdasarkan persentase kesehatan
  const getHealthColor = (percentage) => {
    if (percentage >= 90) return "success";
    if (percentage >= 70) return "info";
    if (percentage >= 50) return "warning";
    return "danger";
  };

  return (
    <div style={{ marginTop: "-23px" }}>
      <h4 className="mb-4" style={{ fontSize: "30px" }}>
        <FontAwesomeIcon icon={faIndustry} className="me-2" />
        Daftar Sektor
      </h4>

      {sectors.length === 0 ? (
        <Card>
          <Card.Body className="text-center p-5">
            <FontAwesomeIcon
              icon={faIndustry}
              size="3x"
              className="text-muted mb-3"
            />
            <h5>Tidak Ada Sektor</h5>
            <p className="text-muted">
              Tidak ada sektor yang tersedia saat ini.
            </p>
          </Card.Body>
        </Card>
      ) : (
        <Row>
          {sectors.map((sector) => (
            <Col key={sector.id} md={6} lg={4} className="mb-4">
              <Card
                className="sector-card h-100"
                style={{ cursor: "pointer" }}
                onClick={() =>
                  navigate(
                    `/maintenance-dashboard/machines?sector=${sector.id}`,
                  )
                }
              >
                <Card.Header
                  className="d-flex justify-content-between align-items-center"
                  style={{ background: "#1e3a8a", color: "#fff" }}
                >
                  <h5 className="mb-0">{sector.name}</h5>
                  <Badge
                    bg={getHealthColor(
                      sectorStats[sector.id]?.healthPercentage || 0,
                    )}
                  >
                    {sectorStats[sector.id]?.healthPercentage || 0}% Sehat
                  </Badge>
                </Card.Header>
                <Card.Body>
                  <p className="text-muted">
                    {sector.description || "Tidak ada deskripsi"}
                  </p>

                  <Table size="sm" className="mt-3">
                    <tbody>
                      <tr>
                        <td>Total Mesin</td>
                        <td className="text-end">
                          <span className="fw-bold">
                            {sectorStats[sector.id]?.totalMachines || 0}
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>Operasional</td>
                        <td className="text-end text-success">
                          {sectorStats[sector.id]?.operational || 0}
                        </td>
                      </tr>
                      <tr>
                        <td>Butuh Perbaikan</td>
                        <td className="text-end text-danger ">
                          {sectorStats[sector.id]?.needMaintenance || 0}
                        </td>
                      </tr>
                      <tr>
                        <td>Sedang Diperbaiki</td>
                        <td className="text-end text-warning">
                          {sectorStats[sector.id]?.underMaintenance || 0}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default SectorsTab;
